export const Options = {
    body: {
        averagePrice: [],
        transactions: []
    },
    views: {
        averagePrice: (self) => {
            return self.averagePrice.toFixed(2);
        },
        transactions: (self) => {
            return self.transactions.toFixed(2);
        }
    }
};
